import React, { useState } from "react";
import {
  FaBug,
  FaCode,
  FaConnectdevelop,
  FaDownload,
  FaExternalLinkAlt,
  FaFigma,
  FaGithub,
  FaMobile,
  FaPaintBrush,
  FaProjectDiagram,
  FaPython,
} from "react-icons/fa";
import Pdf from "../TAadland_Resume.pdf";
import BodyContentHeader from "../common/BodyContentHeader";
import "./Resume.scss";

const Resume = () => {
  const [resumeIndex, setResumeIndex] = useState(0);

  return (
    <div className="body_content_container_child">
      <BodyContentHeader
        headerTitle="Resume"
        headerSubtitle="Status: Open to work"
        imgSrc="planet_1.svg"
        imgAlt="planet 1"
      />

      <div id="resume_content_container">
        <div id="resume_content_texts">
          <div className={`resume_content_text_${resumeIndex === 0}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>UX Design Skills</h2>
              <hr />
              <div id="skill_items">
                <div className="skill_item">
                  <FaFigma color="white" />
                  Figma
                </div>

                <div className="skill_item">
                  <FaPaintBrush color="white" />
                  Adobe XD
                </div>

                <div className="skill_item">
                  <FaProjectDiagram color="white" />
                  Mockups
                </div>

                <div className="skill_item">
                  <FaProjectDiagram color="white" />
                  Prototypes
                </div>

                <div className="skill_item">
                  <FaProjectDiagram color="white" />
                  Wireframes
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  WCAG
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  develop strategies for accessibility
                </div>
              </div>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 1}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>App Development Skills</h2>
              <hr />
              <div id="skill_items">
                <div className="skill_item">
                  <FaCode color="white" />
                  Flutter
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  FlutterFlow
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Android Studio
                </div>

                <div className="skill_item">
                  <FaMobile color="white" />
                  iOS
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Dart programming language
                </div>

                <div className="skill_item">
                  <FaMobile color="white" />
                  Android (mobile operating systems)
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  mobile device software frameworks
                </div>
              </div>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 2}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Web Development Skills</h2>
              <hr />
              <div id="skill_items">
                <div className="skill_item">
                  <FaCode color="white" />
                  REST
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  CSS
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  HTML5
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Web API
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Bootstrap
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Angular
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  ReactJS
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Angular
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  JavaScript Framework
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  JavaScript
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  TypeScript
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  DRF (Django REST framework)
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  JSON
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  implement front-end website design
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Postman
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  HTML Web Page Design
                </div>
              </div>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 3}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Software Development Skills</h2>
              <hr />
              <div id="skill_items">
                <div className="skill_item">
                  <FaGithub color="white" />
                  Git
                </div>

                <div className="skill_item">
                  <FaGithub color="white" />
                  GitHub
                </div>

                <div className="skill_item">
                  <FaPython color="white" />
                  Python
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Visual Studio Code
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  work as a team
                </div>

                <div className="skill_item">
                  <FaBug color="white" />
                  debug software
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  develop software prototype
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  SQL
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  API Integrations
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Object-Oriented Programming
                </div>

                <div className="skill_item">
                  <FaConnectdevelop color="white" />
                  web based collaborative platforms
                </div>
              </div>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 4}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Game Development Skills</h2>
              <hr />
              <div id="skill_items">
                <div className="skill_item">
                  <FaCode color="white" />
                  Unity (digital game creation systems)
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  C#
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Basic Unity Developer Skills
                </div>

                <div className="skill_item">
                  <FaCode color="white" />
                  Game development with Unity 3D
                </div>
              </div>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 5}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Work Experience - MaidCentral</h2>
              <hr />
              <b>
                <i>
                  MaidCentral Software, Remote - Developer (September 2023 -
                  September 2026)
                </i>
              </b>
              <ul>
                <li>lead development for the technician mobile app 2.0</li>
                <li>
                  ensure both iOS and Android compatibility for mobile apps
                </li>
                <li>
                  update existing web app services with SaaS features for
                  customers
                </li>
                <li>troubleshoot and fix bugs in web app services</li>
                <li>
                  improve accessibility of user interfaces, conduct audits
                </li>
              </ul>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 6}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Work Experience - Van Robotics</h2>
              <hr />
              <b>
                <i>
                  Van Robotics, Columbia SC - UI Designer/Developer (July 2018 -
                  August 2023)
                </i>
              </b>
              <ul>
                <li>
                  create wireframes, mockups, and prototypes in Figma for new
                  web features
                </li>
                <li>
                  develop web apps for tutoring children and assisting teachers
                </li>
                <li>implement accessibility for children with special needs</li>
                <li>Created wireframes, mockups, and prototypes with Figma</li>
                <li>
                  facilitated communication between the web apps and robots
                  using APIs
                </li>
              </ul>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 7}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Work Experience - USC Center for Digital Humanities</h2>
              <hr />
              <b>
                <i>
                  USC Center for Digital Humanities, Columbia SC - Full-Stack
                  Web Developer (May 2018 - August 2018)
                </i>
              </b>
              <ul>
                <li>
                  collaborate on a grant-funded web archive of historical media
                </li>
                <li>
                  develop the REST API of the archive using Django and Python
                </li>
                <li>
                  create templates for frontend development and display of media
                </li>
              </ul>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 8}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Education - Degree</h2>
              <hr />
              <h3 style={{ margin: 0 }}>
                University of South Carolina, Columbia SC
              </h3>
              <b>
                <i>B.S. in Computer Science, Minor in Media Arts (2018)</i>
              </b>
            </div>
          </div>

          <div className={`resume_content_text_${resumeIndex === 9}`}>
            <div style={{ fontFamily: "sans-serif", textAlign: "left" }}>
              <h2>Education - Certificates</h2>
              <hr />

              <div className="certifiate_container">
                <h3 style={{ margin: 0 }}>Google UX Design Certificate</h3>
                <b>
                  <i>Coursera</i>
                </b>

                <p
                  style={{ fontWeight: "lighter", margin: "0px 0px 20px 0px" }}
                >
                  Issued April 2023 - No expiration date
                </p>
                <p>
                  <a
                    className="certificate_link"
                    href="https://www.coursera.org/account/accomplishments/specialization/certificate/YY9U2G8NW3YV"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View credential{" "}
                    <FaExternalLinkAlt style={{ marginLeft: "10px" }} />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="resume_btns">
          <a
            id="resume_download_link"
            className={`resume_btn_false`}
            href={Pdf}
            rel="noopener noreferrer"
            target="_blank"
          >
            <FaDownload />
            {` `}Download PDF
          </a>

          <div className={`resume_btn_false experience_btn`}>Skills</div>

          <button
            className={`resume_btn_${resumeIndex === 0} subgroup`}
            onClick={() => setResumeIndex(0)}
          >
            <div className="subgroup_square"></div>UX Design
          </button>
          <button
            className={`resume_btn_${resumeIndex === 1} subgroup`}
            onClick={() => setResumeIndex(1)}
          >
            <div className="subgroup_square"></div>App Development
          </button>
          <button
            className={`resume_btn_${resumeIndex === 2} subgroup`}
            onClick={() => setResumeIndex(2)}
          >
            <div className="subgroup_square"></div>Web Development
          </button>
          <button
            className={`resume_btn_${resumeIndex === 3} subgroup`}
            onClick={() => setResumeIndex(3)}
          >
            <div className="subgroup_square"></div>Software Development
          </button>
          <button
            className={`resume_btn_${resumeIndex === 4} subgroup`}
            onClick={() => setResumeIndex(4)}
          >
            <div className="subgroup_square"></div>Game Development
          </button>

          <div className={`resume_btn_false experience_btn`}>
            Work Experience
          </div>
          <button
            className={`resume_btn_${resumeIndex === 5} subgroup`}
            onClick={() => setResumeIndex(5)}
          >
            <div className="subgroup_square"></div>MaidCentral
          </button>
          <button
            className={`resume_btn_${resumeIndex === 6} subgroup`}
            onClick={() => setResumeIndex(6)}
          >
            <div className="subgroup_square"></div>Van Robotics
          </button>
          <button
            className={`resume_btn_${resumeIndex === 7} subgroup`}
            onClick={() => setResumeIndex(7)}
          >
            <div className="subgroup_square"></div>USC Center for Digital
            Humanities
          </button>

          <div className={`resume_btn_false experience_btn`}>Education</div>
          <button
            className={`resume_btn_${resumeIndex === 8} subgroup`}
            onClick={() => setResumeIndex(8)}
          >
            <div className="subgroup_square"></div>Degree
          </button>

          <button
            className={`resume_btn_${resumeIndex === 9} subgroup`}
            onClick={() => setResumeIndex(9)}
          >
            <div className="subgroup_square"></div>Certificates
          </button>
        </div>
      </div>
    </div>
  );
};

export default Resume;
